module.exports = __webpack_public_path__ + "img/plus_blue.09cd863b.svg";